import * as React from 'react';
import { throttle } from '@cian/newbuilding-utils';
import { Responsive } from '@cian/ui-kit/responsive';

import { Header } from '../../components/Header';
import { ReviewsCountContainer } from './ReviewsCountContainer';
import { ActionButtonsContainer } from './ActionButtonsContainer';
import { getCurrentScrollOffset } from '../../utils/dom/getCurrentScrollOffset';
import { FixedBlock } from '../../components/FixedBlock';
import { STICKY_HEADER_HEIGHT, HEADER_HIDE_ZONE } from '../../constants/elements';

export const HeaderContainer = (): React.JSX.Element => {
  const [isHeaderFixed, setHeaderFixed] = React.useState(false);

  const fixHeader = () => {
    const yOffser = getCurrentScrollOffset();

    if (yOffser > HEADER_HIDE_ZONE) {
      setHeaderFixed(true);
    } else if (yOffser < HEADER_HIDE_ZONE) {
      setHeaderFixed(false);
    }
  };

  const onScrollHandler = throttle(100, fixHeader);

  React.useEffect(() => {
    fixHeader();
    window.addEventListener('scroll', onScrollHandler, false);

    return () => {
      window.removeEventListener('scroll', onScrollHandler, false);
    };
  }, []);

  return (
    <Responsive desktop>
      <FixedBlock top={isHeaderFixed ? 0 : -STICKY_HEADER_HEIGHT}>
        <Header
          isFixed={isHeaderFixed}
          reviewsCount={<ReviewsCountContainer />}
          reviewsButtons={<ActionButtonsContainer />}
        />
      </FixedBlock>
    </Responsive>
  );
};
